import useGetPOS from 'Hooks/teleconsult/useGetPOS';
import { removeModal } from 'Redux/modules/modal/actions';
import { shape, string } from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'semantic-ui-react';

import css from './PointOfSale.less';

import PriceSummary from '@/components/PriceSummary';

const PointOfSale = ({ data, id }) => {
  const { posId } = data;
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(removeModal(id));
  };
  const { pos, loading, getPOSDetails } = useGetPOS();

  useEffect(() => {
    getPOSDetails(posId);
  }, [posId, getPOSDetails]);

  const { subtotal, total, loyaltyAmount, description, currency } = pos ?? {};
  return (
    <div className={css.container}>
      <Modal onClose={onClose} open closeIcon className={css.customModal} style={{ width: 506 }}>
        <Modal.Header>Point of Sale</Modal.Header>
        <Modal.Content className={css.modalContent} style={{ fontSize: 16 }}>
          <div className="font-semibold">Transaction for</div>
          <p>{description ?? '---'}</p>
          <div className="font-semibold">Fee</div>
          <PriceSummary
            total={total}
            subTotal={subtotal}
            loyaltyAmount={loyaltyAmount}
            loading={loading}
            currency={currency}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default PointOfSale;

PointOfSale.propTypes = {
  data: shape({}).isRequired,
  id: string.isRequired,
};
